/* eslint-disable no-irregular-whitespace */
<script>

export default {
  name: 'PolitiqueConfidentialite'
};
</script>

<template>
  <div class="content">
    <h2 class="primary--text mb-6">
      <u><b>POLITIQUE DE PROTECTION DES DONNEES PERSONNELLES</b></u>
      <br><b>Site COMMANDE D’ALIMENTS</b>
    </h2>

    <h3 class="secondary--text">
      Table des matières
    </h3>

    <p>
      <ul>
        <li>Notre engagement pour la protection des données personnelles</li>
        <li>Comment collectons-Nous vos données personnelles ?</li>
        <li>Quelles données personnelles recueillons-nous ?</li>
        <li>Quelles est la politique d’Agrial vis-à-vis des données personnelles des enfants ?</li>
        <li>Quelles utilisations faisons-Nous de vos données personnelles ?</li>
        <li>Agrial divulgue-t-il vos données personnelles et pourquoi ?</li>
        <li>Combien de temps vos données personnelles seront-elles conservées ?</li>
        <li>Comment Agrial protège, stocke et transfère vos données personnelles ?</li>
        <li>Quels sont vos droits et vos choix, comment les exercer ?</li>
        <li>Modifications apportées à notre Politique</li>
      </ul>
    </p>

    <h3 class="secondary--text">
      Introduction
    </h3>
    <p>La présente politique relative à la protection des données personnelles (« la Politique ») a pour but de Vous expliquer comment, au sein de la Coopérative Agrial, ci-après le « Agrial »), Nous collectons vos données personnelles par le biais de notre site Commande d’Aliments. Elle contient également des informations sur le type de données collectées, comment Nous les traitons et dans quelles finalités, de manière à rendre leur utilisation la plus adaptée à vos besoins.</p>

    <p>
      <ul>
        Pour les besoins de la Politique de Confidentialité et Cookies, les termes suivants sont définis comme suit :
        <li>"Nous" ou « Agrial »: se réfère à Agrial pouvant collecter ou traiter vos données personnelles et cookies, ainsi qu’à ses prestataires de services situés en France ou à l'étranger.</li>
        <li>"Vous" ou "Utilisateur" : se réfère à tout utilisateur des services du Site Commande d’Aliments d’Agrial.</li>
      </ul>
    </p>

    <h3 class="secondary--text">
      1. Notre engagement pour la protection des données personnelles
    </h3>

    <p>
      <ul>
        <li>Nous nous efforçons de collecter uniquement les données personnelles nécessaires aux traitements et utilisations envisagées et ce pour les finalités décrites dans la présente Politique</li>
        <li>Si la conservation de vos données n’est pas obligatoire et qu’elles ne sont plus utiles aux traitements de données personnelles, Nous ferons en sorte de les détruire</li>
        <li>Nous respectons vos droits à la vie privée </li>
        <li>Nous sommes soucieux d’être transparents sur notre utilisation de vos données à caractère personnel </li>
        <li>Sachez que certaines de vos données peuvent être obligatoires pour accéder à certains services. Cependant Vous n’avez pas l’obligation de Nous fournir les données personnelles que Nous Vous demandons.</li>
      </ul>
    </p>

    <h3 class="secondary--text">
      2. Comment collectons-Nous vos données personnelles ?
    </h3>
    <p>Nous collectons vos données par tous types de moyens digitaux ; nos sites Internet dont le Site Commande d’Aliments, les pages consacrées aux produits ou marques d’Agrial sur Internet ou sur les réseaux sociaux, les communications électroniques ou vos interactions avec les bannières publicitaires des marques d’Agrial. Toutes vos communications avec nos services Nous permettent aussi de collecter des informations sur Vous. Nous procédons à la collecte de certaines données en utilisant des cookies afin de comprendre vos habitudes et vos actions sur le Site Commande d’Aliments. Dans d’autres cas, Vous Nous communiquez vos informations directement lorsque Vous Nous contactez notamment via les réseaux de conseillers, techniciens, maisons de région, lorsque Vous effectuez une opération ou transaction sur le Site Commande d’Aliments, lors d’animations et évènements en magasin, en ferme, lors de salons professionnels, en remplissant tout type de documents d’enregistrement hors ligne ou en participant à des évènements assemblées réunions, etc….</p>

    <h3 class="secondary--text">
      3. Quelles données personnelles recueillons-nous ?
    </h3>
    <p>
      <ul>
        En fonction de votre mode d’interaction et de communication avec Agrial (en ligne, hors ligne, par téléphone, etc.), Nous pouvons collecter auprès de Vous différents types d’informations, qui diffèrent selon les finalités, tels que décrits ci-après :
        <li>Coordonnées personnelles et démographiques comprenant : civilité, noms, prénoms, sexe, adresses e-mail, date de naissance, adresses postales (notamment de livraison, de facturation), numéros de téléphone, lieux de résidence</li>
        <li>Informations techniques sur les appareils que Vous utilisez pour accéder au Site Commande d’Aliments tels que le système d’exploitation et l’adresse de protocole Internet (IP) </li>
        <li>Données relatives à votre utilisation du Site Commande d’Aliments : dernier site visité, pages consultées</li>
        <li>Informations que Vous partagez directement avec Nous dans le cadre de votre activité agricole professionnelle, en tant qu’adhérent (apporteur, client et associé porteur de parts sociales de la Coopérative Agrial) </li>
        <li>Données financières et de paiement, qui Nous sont nécessaires pour le fonctionnement du compte utilisateur du Site Commande d’Aliments </li>
        <li>Les interactions téléphoniques entre Vous et nos services </li>
        <li>
          Les interactions entre Vous et Nous lors d’évènements, journées, réunions, formations salons professionnels <br>
          Nous n’avons aucune raison de collecter ou de traiter des données personnelles sensibles (par ex. des données de santé) dans le cadre de nos activités commerciales courantes.
        </li>
      </ul>
    </p>

    <h3 class="secondary--text">
      4. Quelles est la politique d’Agrial vis-à-vis des données personnelles des enfants ?
    </h3>
    <p>
      Nous sommes convaincus qu’il est extrêmement important de protéger la vie privée des enfants accédant à Internet et encourageons les parents ou tuteurs à passer du temps avec eux pour participer à et gérer leurs activités en ligne.<br>
      L’accès audit Site Commande d’Aliments est réservée aux personnes majeures.
    </p>
    <h3 class="secondary--text">
      5. Quelles utilisations faisons-Nous de vos données personnelles ?
    </h3>
    <p>Vous trouverez dans le tableau ci-dessous la liste des finalités poursuivies par Agrial lors de la collecte et du traitement de vos données personnelles et les différents types de données personnelles qui sont collectées pour chaque finalité. Sachez que certaines personnes peuvent ne pas être concernées par certaines des utilisations énumérées ci-après.</p>

    <table class="table-utilisations">
      <thead>
        <tr>
          <th style="width: 50%;">
            Quelles utilisations ?
          </th>
          <th style="width: 25%;">
            Principes sur lesquels repose cette utilisation
          </th>
          <th style="width: 25%;">
            Nos intérêts légitimes
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <u>Services de la Branche Agricole et de chacun des métiers de la Coopérative :</u><br>
            <ul>
              Nous utilisons vos données personnelles pour :
              <li>La gestion courante des commandes d’aliments par Vous, et le cas échéant pour répondre à vos demandes, résoudre les éventuels problèmes, améliorer et personnaliser nos services </li>
              <li>La transmission d’informations et suivis des opérations de commandes d’aliments effectuées entre l’Utilisateur et Agrial</li>
              <li>Les Partages d’informations avec des Partenaires d’Agrial, dans le cadre du Service.</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Respect des engagements coopératifs et des obligations contractuelles </li>
              <li>Obligations légales</li>
              <li>Nos intérêts légitimes</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Assurer un suivi de l’activité des adhérents Utilisateurs du Site Commande d’Aliments avec Agrial </li>
              <li>Gagner en efficacité</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <u>Création et gestion du compte adhérent :</u><br> Nous utilisons ces données afin de gérer votre compte sur le Site Commande d’Aliments, compilant les Informations individualisées sur les approvisionnements en aliments de l’Utilisateur, ou Vous adresser des communications adaptées à votre profil.
          </td>
          <td>
            <ul>
              <li>Votre consentement </li>
              <li>Nos intérêts légitimes</li>
              <li>Respect de nos obligations contractuelles</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Nous aider à mieux comprendre vos besoins et vos attentes et, ainsi, améliorer nos services, produits et marques </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            <u>Personnalisation de nos services et offres :</u> <br>
            Avec votre consentement, Nous utilisons vos données personnelles
            <ol type="I">
              <li> pour analyser vos activités et productions </li>
              <li> pour anticiper vos besoins à partir de notre analyse de Votre profil </li>
              <li> pour améliorer et personnaliser votre expérience sur nos sites web et applications </li>
              <li> pour garantir que le contenu provenant de nos sites web ou applications est le plus adapté pour Vous et votre ordinateur ou appareil </li>
              <li> pour vous fournir des publicités et du contenu ciblés </li>
              <li> pour vous permettre de participer à des activités interactives, lorsque Vous le souhaitez.</li>
            </ol>
          </td>

          <td>
            <ul>
              <li>Votre consentement (lorsque c’est nécessaire) </li>
              <li>Nos intérêts légitimes</li>
            </ul>
          </td>

          <td>
            <ul>
              <li>Déterminer lesquels de nos produits et services peuvent Vous intéresser et Vous en parler </li>
              <li>Définir des profils d’Utilisateur pour de nouveaux produits ou services</li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <u>Fonctionnement:</u>
            <br> Nous utilisons vos données personnelles pour garantir une diffusion appropriée de contenus sur nos sites Internet et un paramétrage adapté de votre appareil, y compris la résolution d’écran, etc.
          </td>
          <td>
            <ul>
              <li>Nos intérêts légitimes</li>
              <li>Votre consentement </li>
            </ul>
          </td>

          <td>
            <ul>
              <li>Améliorer notre qualité de service </li>
            </ul>
          </td>
        </tr>

        <tr>
          <td>
            <u>Autres utilisations d'ordre général (étude interne ou étude de marché, analyse, sécurité, etc.) :</u>
            <br> Conformément aux lois en vigueur, Nous utilisons vos données personnelles pour d'autres finalités commerciales d'ordre général, notamment pour réaliser des études internes ou de marché et mesurer l'efficacité de nos campagnes publicitaires, de nos outils de communication (journaux internes, newsletters, lettres de communication électronique, etc).
          </td>
          <td>
            <ul>
              <li>Respect de nos obligations contractuelles</li>
              <li>Votre consentement (lorsque c’est nécessaire) </li>
              <li>Obligations légales</li>
              <li>Nos intérêts légitimes</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Améliorer et développer de nouveaux produits et services </li>
              <li>Gagner en efficacité </li>
              <li>Protéger nos systèmes d’exploitation, nos réseaux et notre personnel</li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            <u>Communications marketing, jeux, concours et autres promotions :</u>
            <br> Avec votre consentement (lorsque c’est nécessaire), Nous utilisons vos données personnelles pour Vous fournir des informations sur nos produits ou services (par exemple, dans le cadre de communications/campagnes marketing ou promotionnelles).
          </td>
          <td>
            <ul>
              <li>Votre consentement (lorsque c’est nécessaire) </li>
              <li>Respect de nos obligations contractuelles</li>

              <li>Nos intérêts légitimes</li>
            </ul>
          </td>
          <td>
            <ul>
              <li>Déterminer lesquels de nos produits et services peuvent Vous intéresser et Vous en parler </li>
              <li>Définir des profils d’Utilisateur pour de nouveaux produits ou services </li>
            </ul>
          </td>
        </tr>
      </tbody>
    </table>
    <br>
    <h3 class="secondary--text">
      6. Agrial divulgue-t-elle vos données personnelles et pourquoi ?
    </h3>
    <p>Lorsque Nous sommes amenés à partager vos données avec nos différents sites internet au sein d’Agrial ou avec d’autres structures (tels que des prestataires de services par exemple), Nous nous assurons que ces organisations disposent également d’une politique de sécurité pour protéger vos données.</p>
    <p>Comme exprimé dans « 1.Notre engagement pour la protection des données personnelles », vos données personnelles ne seront pas partagées, vendues, louées ou divulguées pour des finalités autres que celles décrites dans la Politique. De ce fait, à l’exception des cas où Vous avez donné votre consentement, Nous ne vendrons pas vos données personnelles à des sociétés tierces pour leurs propres finalités marketing. Néanmoins, il est possible que vos données soient transmises si elles sont requises par la loi et les autorités gouvernementales par exemple. En cas de cession d’une activité d’Agrial à une autre société, le successeur légal aura accès aux données détenues par l’entité cédante et donc probablement à certaines de vos données personnelles.</p>

    <h3 class="secondary--text">
      7. Combien de temps vos données personnelles seront-elles conservées ?
    </h3>

    <p>
      Vos données personnelles seront conservées par Agrial seulement pour le temps qui est raisonnablement nécessaire aux finalités décrites dans la présente Politique.
      <br> Les critères que Nous utilisons pour déterminer les durées de conservation de vos données personnelles sont les suivants :
    </p>
    * Agrial gardera vos données personnelles dans une forme permettant votre identification :
    <ul>
      <li>jusqu’au terme de votre engagement coopératif ou au terme du retrait de la coopérative; ou </li>
      <li>pendant une durée de douze mois après l’arrêt du Service ou du Site Commande d’Aliments; ou</li>
      <li>pendant une durée de quarante-huit mois après la clôture du compte Utilisateur sur le site Commande d’Aliments.</li>
    </ul>
    <p>* Si Vous Nous contactez dans le cadre d’une demande, nous conservons vos données à caractère personnel pendant toute la durée nécessaire au traitement de votre demande; * Si Vous créez un compte, Nous conservons vos données à caractère personnel jusqu’à ce que Vous Nous demandiez de procéder à leur suppression ou à l’issue d’une période d’inactivité (aucune interaction active avec les marques) définie conformément aux règlementations et instructions au niveau local.</p>
    <p>Vos données personnelles sont toutefois susceptibles d’être conservées plus longtemps au titre d’obligations légales spécifiques ou au regard des délais de prescription légale applicables. </p>
    <p>Au-delà des durées de conservation mentionnées ci-dessus, vos données personnelles seront soit supprimées de toutes les bases de données d’Agrial de façon sécurisée, soit anonymisées.</p>

    <h3 class="secondary--text">
      8. Comment Agrial protège, stocke et transfère vos données personnelles ?
    </h3>

    <p>Nous utilisons toutes les mesures techniques et organisationnelles nécessaires afin de garantir la confidentialité et la sécurité de vos données personnelles. Sachez toutefois que ces mesures ne concernent pas les informations que Vous choisissez de partager sur des espaces publics, notamment sur des réseaux sociaux tiers.</p>
    <p>Concernant vos données financières, Nous appliquons les standards de l’industrie en matière de protection et respectons les obligations légales. </p>
    <p>Vous pouvez aussi Nous aider à garantir la protection de vos données en utilisant les paramètres de confidentialité du Site Commande d’Aliments, en choisissant un mot de passe de connexion complexe et en étant vigilant lors de la connexion à votre compte sur un appareil public. </p>
    <p>Le stockage ainsi que le traitement de vos données personnelles nécessitent que vos données personnelles soient, à un moment ou un autre, transférées vers, et stockées dans un pays autre que celui où Vous résidez. Les données personnelles peuvent être traitées en dehors de l’Espace Economique Européen (EEE). Si c’est le cas, Agrial mettra tout en œuvre pour que ce transfert international de données dispose d’un niveau et de garanties de sécurité adéquats. Les garanties que Nous utilisons pour protéger les transferts internationaux de données incluent (i) des clauses contractuelles types validées par la Commission Européenne, (ii) des mécanismes de certifications qui attestent que les tiers situés hors EEE traitent les données personnelles de manière conforme à la Réglementation. </p>

    <h3 class="secondary--text">
      9. Quels sont vos droits et vos choix, comment les exercer ?
    </h3>

    <p>Nous avons à cœur de Vous permettre de faire valoir vos droits et faire les choix les plus éclairés possibles, s'agissant des données personnelles que Vous Nous fournissez.</p>
    <p>Dans le tableau suivant, Nous entendons par Vous : « vous-même, vos descendants, représentants et /ou mandataires »</p>

    <table class="table-droits">
      <thead>
        <tr>
          <th style="width: 40%;">
            Vos droits
          </th>
          <th style="width: 60%;">
            Qu’est-ce que cela signifie ?
          </th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>
            Le droit à l’information
          </td>
          <td rowspan="2">
            Vous avez le droit d'accéder à, de consulter et de demander une copie physique ou électronique des informations que Nous détenons à votre sujet ainsi que sur la manière dont Nous les utilisons. Ces informations doivent être transparentes, claires et aisément compréhensibles. Vous avez également le droit de demander des informations sur la provenance de vos données personnelles.
          </td>
        </tr>
        <tr>
          <td>
            Le droit à l’accès
          </td>
        </tr>

        <tr>
          <td>
            Le droit à la modification
          </td>
          <td rowspan="2">
            Vous pouvez demander la suppression, la portabilité, la rectification ou la modification de vos données personnelles ; si elles sont inexactes ou périmées et/ou soient complétées si elles sont incomplètes.
          </td>
        </tr>
        <tr>
          <td>
            Le droit à la suppression / à l’oubli
          </td>
        </tr>

        <tr>
          <td>
            Le droit à la gestion de vos données fournies
          </td>
          <td>
            Nous pouvons également être obligés de conserver certaines de vos données personnelles, après votre demande de suppression, dans le but de satisfaire à nos obligations légales ou contractuelles.
          </td>
        </tr>

        <tr>
          <td>
            Le droit à la limitation du traitement
          </td>
          <td rowspan="2">
            Ces droits signifient que le traitement des données vous concernant auquel Nous procédons est limité, de sorte que Nous pouvons conserver ces données, mais pas les utiliser ni les traiter.
          </td>
        </tr>
        <tr>
          <td>
            Le droit d’opposition au traitement des données basé sur notre intérêt légitime
          </td>
        </tr>

        <tr>
          <td>Le droit à l’annulation de votre consentement </td>
          <td>Vous pouvez retirer votre consentement à l'une quelconque de nos activités de traitement de vos données personnelles si elle est fondée sur le consentement. Le retrait de ce consentement ne porte pas atteinte à la licéité du traitement fondé sur le consentement effectué avant le retrait de celui-ci.</td>
        </tr>

        <tr>
          <td>Le droit à la réclamation auprès d'une autorité de contrôle </td>
          <td>Vous avez le droit de saisir et d’introduire une réclamation auprès de l’autorité de protection des données, La CNIL (https://www.cnil.fr/fr/plaintes), pour contester les pratiques d’Agrial en matière de protection des données à caractère personnel et de respect de la vie privée. </td>
        </tr>
        <tr>
          <td>Le droit à la non-prospection </td>
          <td>A tout moment, en Nous contactant ou en cliquant sur le lien de « désinscription » dans tout courriel ou toute communication que Nous Vous envoyons, Vous pouvez vous opposer à la réception de nos messages de prospection commerciale </td>
        </tr>

        <tr>
          <td>Le droit à la désactivation ou gestion des Cookies </td>
          <td>Vous pouvez régler les paramètres de votre navigateur pour désactiver les Cookies ou être alerté lorsque des cookies/technologies similaires sont utilisés. Cependant, cela peut Vous empêcher d’utiliser certaines parties du Site Commande d’Aliments. </td>
        </tr>

        <tr>
          <td>Le droit au blocage des publicités ciblées </td>
          <td>
            Nous pouvons être partenaire d’annonceurs publicitaires faisant apparaitre sur Internet des bannières publicitaires, ciblées sur vos centres d’intérêt, pour l’une de nos marques ou des marques de sociétés extérieures à Agrial.
            Vous pouvez consulter le site Internet www.aboutads.info/choices pour en savoir plus sur la façon dont Vous pouvez bloquer l’apparition de ces publicités ciblées
          </td>
        </tr>
      </tbody>
    </table>
    <br>
    <p>Vous pouvez exercer ces droits comme indiqué dans les mentions légales du Site Commande d’Aliments. </p>
    <p>Nous Vous demanderons de joindre à votre demande une copie de votre pièce d'identité ou tout autre justificatif d'identité. Si la demande est soumise par une personne autre que Vous, sans preuve que la demande est légalement formulée en votre nom, la demande sera rejetée.</p>
    <p>Sachez que toute information qui Nous sera fournie sera traitée uniquement en conformité avec, et dans la mesure permise par, les lois en vigueur.</p>
    <p>Nous traiterons et examinerons toute réclamation relative à la manière dont Nous gérons vos données personnelles (y compris une réclamation indiquant que Nous avons porté atteinte à vos droits selon les lois sur la protection de la vie privée en vigueur).</p>

    <h3 class="secondary--text">
      10. Modifications apportées à notre Politique
    </h3>

    <p>
      En cas de modification dans la manière dont Nous gérons et traitons vos données personnelles, Nous mettrons à jour la présente Politique. Nous nous réservons le droit de modifier nos pratiques et cette Politique à tout moment.
      <br> Merci de vérifier régulièrement la présence de mises à jour ou de modifications dans notre Politique.
    </p>
    <br>
    <br>
    <br>
    <br>
  </div>
</template>

<style lang="scss" scoped>
.content {
  margin: 3vw;
  padding: 2vw;
  background-color: #f4f8f9;
}

.secondary--text {
  font-weight: 300;
  text-decoration: underline;
}

table,
thead,
th,
tr,
td {
  border-collapse: collapse;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.36);
}

td {
  padding-left: 10px;
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .content {
    margin: 0;
    padding: 3vw;
  }

  table {
    thead {
      display: none;
    }
    tr {
      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      width: 100%;
      margin-bottom: 1.5em;
      & > * {
        width: 100%;
      }

      td {
        position: relative;
        margin-top: 1.5em;
        // max-width: 95vw;
        &::before {
          position: absolute;
          width: 100%;
          height: 1.5em;
          left: 1em;
          top: -1.5em;
          font-weight: bold;
        }
      }
    }
  }

  .table-utilisations {
    td:nth-of-type(1):before {
      content: "Quelles utilisations ?";
    }
    td:nth-of-type(2):before {
      content: "Principes sur lesquels repose cette utilisation";
    }
    td:nth-of-type(3):before {
      content: "Nos intérêts légitimes";
    }
  }

  .table-droits {
    td:nth-of-type(1):before {
      content: "Vos droits";
    }
    td:nth-of-type(2):before {
      content: "Qu’est-ce que cela signifie ?";
    }
  }
}
</style>
